export const ERROR_PAGE_CONS = {
  title: 'Technical Error',
  description: 'Something went wrong on our end. Try again or come back later.',
  try_again: 'Try again'
};

// Translation configuration for error page
export const ERROR_PAGE_TRANSLATION_CONFIG = [
  { key: 'ERROR_PAGE_CONS', value: ERROR_PAGE_CONS, message: JSON.stringify(ERROR_PAGE_CONS) }
];

// Helper function to process translated items
export const processErrorPageTranslations = (translatedItems: any) => {
  if (!translatedItems || Object.keys(translatedItems).length === 0) {
    translatedItems = {};
  }

  const parsedCons = translatedItems[JSON.stringify(ERROR_PAGE_CONS)];
  let consTranslated = ERROR_PAGE_CONS;

  if (parsedCons) {
    try {
      consTranslated = typeof parsedCons === 'string' ? JSON.parse(parsedCons) : parsedCons;
    } catch {
      consTranslated = ERROR_PAGE_CONS;
    }
  }

  return {
    ERROR_PAGE_CONS: consTranslated
  };
};
